<template>
  <div id="app" :class="$store.state.offline_atlas.fullScreen ? 'talentMapFullScreen' : ''" @mousedown="operation" @mouseup="operation">
    <!-- <div>
      <el-button @click="playAudio" type="linear">播放</el-button>
    </div> -->
    <template>
      <router-view v-if="$route.meta['menuType'] === 'menu'"/>
      <router-view v-else></router-view>
    </template>
    <div v-if="$store.state.audio.audioMsg['isShowAudio']" class="recorder">
      <my-audio-recorder
        ref="recorder"
        :playerWidth="playerWidth"
        :playerHeight="playerHeight"
        :fileList="fileList"
        @close="closeAudioConfirm"
        :audioData="audioData"
        :audioType="audioType"
      >
      </my-audio-recorder>
       
    </div>
    <div class="recorder" v-if="$store.state.audio.truelandUiAudioMsg['isShowAudio']">
      <!-- 这个只负责播放录音 -->
      <AudioRecorder
        ref="oldRecorder"
        :playerWidth="playerWidth"
        :playerHeight="playerHeight"
        :audioData="oldAudioData"
        :audioType="audioType"
        :fileList="oldFileList"
        @permissioned="permissioned"
        @download="downloadHandler"
        @close="oldCloseAudioConfirm"
        @pauseHandler="playAndPauseHandler"
        @playHandler="playAndPauseHandler"
      >
      </AudioRecorder>
    </div>
    <!-- AI Chat 组件统一管理 -->
    <aiChat
      v-if="$store.state.aiChat.aiChatDrawerVisible"
      :suggestQuestions="$store.state.aiChat.suggestQuestions"
      :interview="$store.state.aiChat.interview"
      :source="$store.state.aiChat.source"
      @close="handleAiChatClose"
    />
  </div>
</template>

<script>
import  myAudioRecorder  from '@/components/audioRecorder'
import { audioRecorder } from '@/components/audioRecorder'
import aiChat from '@/components/aiChat'
import store from '@/store'
import COS from 'cos-js-sdk-v5'
import { Api } from '@/api'
import dayjs from 'dayjs'
import { downFile } from '@/utils/tools'
import Cookies from 'js-cookie'
import { debounce } from 'throttle-debounce'
import mixin from '@/components/audioRecorder/mixin/index.js'
export default {
  name: 'App',
  mixins: [mixin],
  components: {
    myAudioRecorder,
    aiChat
  },
  computed: {
    audioMsgs() {
      return this.$store.state.audio.audioMsg['row']
    },
    audioStatus() {
      return this.$store.state.audio.playStatus
    },
    fileList: {
      get() {
        return this.$store.state.audio.audioMsg.fileList
      },
      set(val) {
        console.log('set-fileList', val)
      }
    },
    oldFileList(){
      return this.$store.state.audio.truelandUiAudioMsg.fileList
    },
    audioType() {
      return this.$store.state.audio.truelandUiAudioMsg.type
    },
    userInfos() {
      return this.$store.state.user.userInfos
    },
    oldAudioData(){
      return {
        title:this.$store.state.audio.truelandUiAudioMsg.title
      }
    },
  },
  watch: {
    'audioMsgs': function() {
      const info = this.$store.state.audio.audioMsg
      let title = null
      const rows = info['row']
      if (this.$store.state.audio.audioMsg.type === 0) {
        // 录音
        if (info['row'] && info['audioType']) {
          let interview = null
          let assess = null
          const type = info['audioType']
          // rows.interviewList && rows.interviewList.length > 0 &&
          if (type === 'interview') {
            // 面试录音
            if (rows.interviewList) {
              interview = rows.interviewList[rows.interviewList.length - 1]
              title = dayjs().format('YYYY-MM-DD HHmmss') + '-' + interview.userName + '-' + interview.jobName +
                '-' + interview.interviewer + '-' + interview['turnsCount']
            } else {
              console.log(rows.interviewer, '===eq===rows.interviewer')
              if (rows.interviewer) {
                title = (dayjs().format('YYYY-MM-DD HHmmss') + '-' + rows.name + '-' + rows.jobName + `${rows.interviewer ? '-' + rows.interviewer : ''}`)
              } else {
                title = (dayjs().format('YYYY-MM-DD HHmmss') + '-' + rows.name + '-' + rows.jobName + `${this.userInfos?.cnName ? '-' + this.userInfos?.cnName : ''}`)
              }
              // title = (dayjs().format('YYYY-MM-DD HH:mm:ss') + '-' + rows.userName + '-' + rows.jobName + '-' + rows.interviewer + '-' + rows.turnsCount)
            }
          }
          // rows['trainVerifyDetailReturns'] && rows['trainVerifyDetailReturns'].length > 0 &&
          if (type === 'assess') {
            // 考核录音
            assess = rows
            // 录音
            title = dayjs().format('YYYY-MM-DD HH:mm:ss') + '-' + assess.userName + '-' + assess.jobName + '-' + assess['currentUserName']
            //  + assess.type
          }
        }
      } else {
        // 播放器
        if (info['source'] && info.fileList && info['row']) {
          const source = info['source']
          this.fileList = Array.isArray(info.fileList) ? info.fileList : [info.fileList]
          title = source.fileName
        } else {
          this.fileList = info.source
          title = info['title']
        }
      }
      this.audioData = {
        title: title || '',
        id: 1,
        uploadPercent: null,
        row: rows,
        resumeId: rows ? rows.id : '',
        jobId: 1
      }
      this.$nextTick(() => {
        if (this.$refs['recorder'] && this.$store.state.audio.audioMsg.isShowAudio && this.$store.state.audio.audioMsg['type'] !== 0) {
          setTimeout(() => {
            this.$refs['recorder'].playHandler()
          }, 300)
        }
      })
    },
    'audioStatus': {
      handler(newVal, oldVal) {
        console.log(this.$store.state.audio.audioMsg, 11111)
        if (oldVal) {
          if (newVal === false) {
            if (this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(() => {
              this.$refs['recorder'] && this.$refs['recorder'].pauseHandler()
            }, 300)
          } else if (newVal === 'close') {
            if (this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(() => {
              this.$refs['recorder'] && this.$refs['recorder'].playHandler()
            }, 300)
          }
        } else if (oldVal === false) {
          if (this.timer) clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.$refs['recorder'] && this.$refs['recorder'].playHandler()
          }, 300)
        }
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      timer: null,
      playerWidth: 420, // 仅针对audioType = 1有作用
      playerHeight: 176, // 仅针对audioType = 1有作用
      audioData: { // audioType = 0的时候，需要传入的数据
        title: dayjs().format('YYYY-MM-DD') + ' ' + '面试录音',//271494
        id: 1,
        resumeId: 1,
        jobId: 1,
      },
      file: null,
      audioTimer: null,
    }
  },
  methods: {
    // AI Chat 关闭时重置参数
    handleAiChatClose() {
      this.$store.commit('aiChat/resetAiChatData');
      this.$store.commit('aiChat/setVisible', false);
    },
    playAndPauseHandler(val, index) {
      console.log('val=====', val, index)
      this.$store.dispatch('audio/setPlayStatus', { flag: val, index: index })
    },
    /** 音视频上下文件切换 **/
    // nextAndPreviousHandler(index) {
    //   this.$store.dispatch('nextAndPrevious', index)
    // },
    permissioned() {
      if (this.$refs['oldRecorder']) {
        this.$refs['oldRecorder']?.playHandler()
      } else {
        this.$nextTick(() => {
          if (this.$refs['oldRecorder'] && this.$store.state.audio.truelandUiAudioMsg?.isShowAudio) {
            // if (this.timer) clearTimeout(this.timer)
            // this.timer = setTimeout(() => {
            //   this.$refs['recorder'].playHandler()
            // }, 300)
            this.$refs['oldRecorder']?.playHandler()
          }
        })
      }
    },
    closeAudio() {
      const audioMsg = {
        title: null,
        isShowAudio: false,
        row: null,
        fileList: [],
        source: null,
        type: null
      }
      this.$store.dispatch('audio/setAudioMsg', audioMsg)
      this.$store.dispatch('audio/setPlayStatus', 'close')
      this.$store.dispatch('audio/setAudioMsgDoneData', null)
      this.$store.commit('audio/setRelationId','');//251904
    },
    closeAudioConfirm() {
      const audioMsg = {
        title: null,
        isShowAudio: false,
        row: null,
        fileList: null,
        source: null,
        audioType: null,
        type: null,
        doneData: null,
        id:'',
        relationId:'',
      }
      this.$store.commit('audio/setAudioMsg',audioMsg);
    },
    oldCloseAudioConfirm(){
      const audioMsg = {
        title: null,
        isShowAudio: false,
        row: null,
        fileList: null,
        source: null,
        audioType: null,
        type: null,
      }
      this.$store.commit('audio/setTruelandUiAudioMsg',audioMsg);
    },
    playAudio() {
      // if (this.$store.state.audio.audioMsg.isShowAudio) {
      //   this.$message.error('请先关闭当前音频')
      // }
      this.$store.dispatch('audio/setPlayStatus', { flag: true, index: null })
      this.$store.dispatch('audio/setAudioMsg', {
        isShowAudio: true,
        title: '哈哈哈哈哈',
        type: 1,
        fileList: [
          {
            id: 1,
            fileUrl: 'http://downsc.chinaz.net/Files/DownLoad/sound1/201906/11582.mp3',
            fileTitle: '音频资源在线播放'
          }
        ]
      })
    },
    // audioType = 1 代表音频或者视频的下载, 有一个回调函数，下载成功了传入true，原因是需要让组件里面的loading变成正常状态
    downloadHandler(data, callBack) {
      console.log('视频或者音频下载data====', data, callBack)
      downFile(data.fileUrl, data.fileTitle)
      callBack(true)
    },
    // 停止录音并上传（audioType = 0录音时调用）
    audioComplete(blob, row) {
      console.log('blob===', blob, row)
      if (!blob) {
        this.closeAudio()
        return
      }
      if (this.loadingSorce) {
        return
      }
      const file = new window.File([blob], row.title + '.wav', { type: 'audio/wav' })
      this.file = { file: file }
      const that = this
      that.loadingSorce = true
      this.$store.dispatch('audio/setAudioMsgDoneData', null)
      that.uploadNormal(this.file)
    },
    uploadDencryption(file) {
      // 腾讯云加密文件处理
      const that = this
      Api.generatorTempSecretId({ filename: encodeURIComponent(file.file.name) })
        .then(res => {
          console.log(res, 'resres')
          if (res && res.code === '0') {
            // this.action = urls.data.uploadUrl
            return res
          }
        })
        .then(res => {
          var cos = new COS({
            getAuthorization: function(options, callback) {
              callback({
                TmpSecretId: res.data.tmpSecretId,
                TmpSecretKey: res.data.tmpSecretKey,
                XCosSecurityToken: res.data.sessionToken,
                StartTime: res.data.startTime,
                ExpiredTime: res.data.expiredTime
              })
            }
          })
          cos.sliceUploadFile(
            {
              Bucket: res.data.bucket /* 必须 */,
              Region: res.data.region /* 存储桶所在地域，必须字段 */,
              Key: res.data.path /* 必须 */,
              Body: file.file,
              uploadId: res.data.uploadId,
              onTaskReady: function(taskId) {
                /* 非必须 */
                that.taskId = taskId
                that.$emit('cancelUp', cos, taskId)
              },
              onHashProgress: function(progressData) {
                /* 非必须 */
                // console.log(JSON.stringify(progressData), '2')
              },
              onProgress: function(progressData) {
                that.$emit('progress', progressData)
                console.log(progressData, 'progressData')
                that.audioData.uploadPercent = parseInt(String(progressData.percent * 100))

                /* 非必须 */
                // console.log(JSON.stringify(progressData), '3')
              }
            },
            function(err, data) {
              console.log(res.data, 'sssssssssss1')
              console.log(data, '腾讯云返回数据')
              if (err) {
                that.$message.warning('文件上传失败,请重新上传')
                that.$emit('uploadFailed')
              } else {
                // 返回path 然后页面加载通过getDownloadUrl请求获取地址
                that.$emit('uploadSuccess', {
                  name: file.name,
                  path: data.Key,
                  //   id: data.UploadId,
                  uploadType: that.uploadType
                }, that.previewFileList)
              }
            }
          )
        })
        .catch(e => {
          that.$emit('uploadFailed')
        })
    },
    uploadNormal(file) {
      // 不加密文件
      var that = this
      // cos非加密方法暂时保留 签名：generatorSign 临时签名generatorTempSecretId
      Api.generatorTempSecretId({ filename: encodeURIComponent(file.file.name), type: 1 }).then(res => {
        if (res && res.code === '0') {
          console.log(res, 'resres')
          var cos = new COS({
            SecretId: res.data.tmpSecretId,
            SecretKey: res.data.tmpSecretKey,
            XCosSecurityToken: res.data.sessionToken
          })
          cos.sliceUploadFile(
            {
              Bucket: res.data.bucket /* 填写自己的 bucket，必须字段 公共桶 */,
              Region: res.data.region /* 存储桶所在地域，必须字段 */,
              Key: res.data.path /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
              Body: file.file, // 上传文件对象
              onTaskReady: function(taskId) {
                /* 非必须 */
                console.log(taskId)
              },
              onHashProgress: function(progressData) {
                /* 非必须 */
                // console.log(JSON.stringify(progressData), '2')
              },
              onProgress: function(progressData) {
                console.log('当前进度：', parseInt(String(progressData.percent * 100)))
                that.audioData.uploadPercent = parseInt(String(progressData.percent * 100))
                /* 非必须 */
                // console.log(JSON.stringify(progressData), '3')
              }
            },
            that.uploadCallback
          )
        }
      })
    },
    uploadCallback: function(err, data) {
      const that = this
      if (err) {
        that.$message.warning('文件上传失败,请重新上传')
        that.audioData.uploadPercent = null
        that.loadingSorce = false
        that.$emit('uploadFailed')
        that.$store.dispatch('audio/setAudioMsgDoneData', null)
      } else {
        that.$message.success('录音上传成功')
        console.log('uploadCallbackuploadCallback', data, that.$store.state.audio.audioMsgDoneData)
        const doneData = {
          status: 'success',
          name: that.file.file.name,
          path: 'https://' + data.Location,
          url: 'https://' + data.Location,
        }
        that.$store.dispatch('audio/setAudioMsgDoneData', doneData)
        let timer = setTimeout(() => {
          that.audioData.uploadPercent = null
          that.loadingSorce = false
          that.closeAudio()
        }, 1000)
        that.$once('hook:beforeDestroy', () => {
          clearTimeout(timer)
          timer = null
        })
      }
    },
    bindEvent() {
      window.addEventListener('message', this.handleEvent)
    },
    handleEvent(e) {
      if (e.data.extensionVersion) {
        this.$store.state.app.extensionVersion = e.data.extensionVersion
      }
    },
    operation(){
      const token = Cookies.get('dhr-Token');
      if(window.currentWebToken && token && window.currentWebToken != token){
        //说明账号切换过了
        alert('账号已切换，请刷新浏览器！');
        window.location.reload();
      }
    },
    buryingPointInit(){
      const that = this;
      const classList = '.el-button,.el-menu-item,.el-radio-button__inner,.el-tabs__item,.label-tag,.can-click,.el-switch,.el-input,.el-dropdown-menu__item,.dropdown-item,.leftJobBtn,.el-icon-setting,.el-tag,.iconfont,.el-tooltip,.edit-style,.interest-style,.box-title,.el-tree-node__label,.number,.el-checkbox__inner,.el-link--inner,.blue-title'
      this.$nextTick(()=>{
        $('body').on('mousedown', classList, function(e) {
          that.buryingPointClickLogic(this);
        });
      })
    },
    buryingPointClickLogic: debounce(500, function(that) {
      const userInfos = this.$store.state.user.userInfos
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      let pageTitle = '';
      for(let i = 0 ; i < matched.length; i++){
        if(matched[i].meta && matched[i].meta.title){
          pageTitle = pageTitle + '/' + matched[i].meta.title;
        }
      }
      const buttonClass = $(that).attr('class');
      const buttonName = $(that).text() || $(that).attr('placeholder');
      
      const data = {
        accountId:userInfos.accountId,
        userId:userInfos.loginUserId,
        userName:userInfos.cnName,
        pageUrl:window.location.href,
        pageTitle,
        buttonClass,
        buttonName:buttonName ? buttonName.substring(0, 50) : '',
        productCode:'zzp',
      }
      // bug：336596 简历详情埋点：点击打开简历详情抽屉/新窗口打开简历详情，以及简历详情抽屉内的点击，都带上candidateId(简历id)和candidateName(候选人姓名)
      const transientCandidate = window.__resumeDetailTransientCandidate // 一次性：新窗口打开简历详情时，源页面本次点击携带
      const drawerCandidate = window.__resumeDetailCandidate // 持续：简历详情抽屉打开期间携带
      const candidate = transientCandidate || drawerCandidate
      if (candidate && (candidate.id || candidate.name)) {
        data.candidateId = candidate.id || ''
        data.candidateName = candidate.name || ''
      }
      // 一次性候选人信息用完即清，避免污染源页面后续的其它点击埋点
      if (transientCandidate) {
        window.__resumeDetailTransientCandidate = null
      }
      //console.log('埋点参数',that,data)

      Api.savePageVisit(data)
    }),
  },
  created() {
    this.bindEvent()
  },
  mounted(){
    if (['pre','prod'].includes(process.env.NODE_ENV)) {
      this.buryingPointInit();
    }
    if(this.audioTimer === null){
      this.audioTimer = setTimeout(()=>{
        this.uploadLogs();
      },2000)
    }
  }
}
</script>

<style lang="scss">
#app {
  min-width: 1440px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-x: auto;//修改bug：219772
}

.bottom-menu .slider .el-slider__button{
  left: -4px;
}
.recorder{
   .draggable{
     z-index: 9999;
     position: fixed !important;
     right: 0 !important;
     bottom: 60px !important;
   }
   .modal-container{
     z-index: 9999;
   }
  .slider{
    padding-left: 8px;
    padding-right: 8px;
    .el-slider__button{
      left: 0;
    }
  }
 }
 .talentMapFullScreen{
    .gray-sub-box{
      display: none !important;
    }
    .talentPoolAI_left{
      display: none !important;
    }
    .sidebar-container{
      display: none !important;
    }
    .main-container{
      margin-left:0 !important;
      height: 100% !important;
    }
    .navbar{
      display: none !important;
    }
    .talentPoolAI_right{
      width: 100% !important;
    }
    .page_talentMap{
      height: 100% !important;
      padding: 10px !important;
    }

 }
.el-picker-panel__icon-btn{
    padding: 0px;
}
</style>
